<script lang="ts">
  export let variant:
    | "calendar"
    | "deals"
    | "videos"
    | "games"
    | "news"
    | "video"
    | "banner"
    | "daily"
    | "daily-short";
  export let tiles: number;
</script>

<div>
  {#if variant === "calendar"}
    <div
      class="ml-left bg-neutral-59/50 pr-right mb-4 h-7 w-1/3 animate-pulse rounded text-lg font-semibold" />
    <div class="pl-left pr-right scrollbar-hide flex gap-3 overflow-scroll scroll-auto">
      {#each new Array(tiles).fill(undefined) as _}
        <div
          class="bg-neutral-59/50 m-px block aspect-[5/6] h-24 animate-pulse rounded" />
      {/each}
    </div>
  {:else if variant === "deals"}
    <div
      class="bg-neutral-59/50 pr-right mb-4 h-7 w-1/3 animate-pulse rounded text-lg font-semibold" />
    <div class="grid grid-cols-2 grid-rows-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
      {#each new Array(tiles).fill(undefined) as _}
        <div class="bg-neutral-59/50 m-px aspect-square animate-pulse rounded" />
      {/each}
    </div>
  {:else if variant === "videos"}
    <div
      class="bg-neutral-59/50 pr-right h-7 w-1/3 animate-pulse rounded text-lg font-semibold" />
    <div
      class="scrollbar-hide box-border grid grid-cols-1 gap-4 overflow-scroll scroll-auto sm:grid-cols-2">
      {#each new Array(tiles).fill(undefined) as _}
        <div
          class="bg-neutral-59/50 m-px block aspect-video w-full animate-pulse rounded" />
      {/each}
    </div>
  {:else if variant === "games"}
    <div
      class="bg-neutral-59/50 pr-right mb-4 h-7 w-1/3 animate-pulse rounded text-lg font-semibold" />
    <div class="grid grid-cols-2 grid-rows-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
      {#each new Array(tiles).fill(undefined) as _}
        <div class="bg-neutral-59/50 m-px aspect-square animate-pulse rounded" />
      {/each}
    </div>
  {:else if variant === "news"}
    <div
      class="bg-neutral-59/50 pr-right h-7 w-1/3 animate-pulse rounded text-lg font-semibold" />
    <div
      class="scrollbar-hide box-border grid grid-cols-1 gap-4 overflow-scroll scroll-auto sm:grid-cols-2">
      {#each new Array(tiles).fill(undefined) as _}
        <div
          class="bg-neutral-59/50 m-px block aspect-video w-full animate-pulse rounded" />
      {/each}
    </div>
  {:else if variant === "video"}
    <div class="bg-neutral-59/50 m-px block aspect-video w-full animate-pulse rounded" />
  {:else if variant === "banner"}
    <div class="bg-neutral-59/50 m-px block aspect-[4/1] w-full animate-pulse rounded" />
  {:else if variant === "daily"}
    <div
      class="bg-neutral-59/50 mx-auto block h-[640px] w-[370px] animate-pulse rounded" />
  {:else if variant === "daily-short"}
    <div class="bg-neutral-59/50 m-px block aspect-[9/16] w-full animate-pulse rounded" />
  {/if}
</div>
